import { ScanText, X } from "lucide-react"

import { CAMPOS, NOMBRE_ARCHIVO, type Propuesta } from "@/componentes/personas/lectorPersonal"

/**
 * Lo que una lectura IA añade a un ALTA, además de los cuatro campos del formulario.
 *
 * ⚠ **El alta enseña nombre, apellidos y cédula; el resto de lo leído viaja igual**,
 * y por eso se dice aquí qué es. Sin este resumen, quien crea la ficha no sabría que
 * con ella entran la fecha de nacimiento, el RIF, los estudios y tres archivos.
 */

/** Los campos que el formulario del alta ya enseña: no se repiten en el resumen. */
export const DEL_FORMULARIO = ["nombres", "apellidos", "tipo_documento", "documento"] as const

/** Lo que la lectura añade al cuerpo del `POST /personas`, sin lo del formulario. */
export function extrasDeLaLectura(p: Propuesta | null): Record<string, unknown> {
  if (p === null) return {}
  const extras: Record<string, unknown> = { lectura_id: p.lectura_id }
  for (const [campo, valor] of Object.entries(p.campos)) {
    if (!(DEL_FORMULARIO as readonly string[]).includes(campo)) extras[campo] = valor
  }
  if (p.estudios !== null) extras.estudios = p.estudios
  if (p.experiencias !== null) extras.experiencias = p.experiencias
  return extras
}

export function ResumenLecturaAlta({
  propuesta,
  onDescartar,
}: {
  propuesta: Propuesta
  onDescartar: () => void
}) {
  const campos = CAMPOS.filter(
    (c) => !(DEL_FORMULARIO as readonly string[]).includes(c.ficha) && c.ficha in propuesta.campos,
  ).map((c) => c.rotulo.toLowerCase())
  const partes = [
    ...campos,
    ...(propuesta.estudios?.length ? [`${propuesta.estudios.length} estudios`] : []),
    ...(propuesta.experiencias?.length ? [`${propuesta.experiencias.length} empleos`] : []),
  ]
  return (
    <div className="superficie mb-4 space-y-1 p-3 text-sm" role="status">
      <p className="flex items-center gap-2 font-medium">
        <ScanText size={16} aria-hidden={true} style={{ color: "var(--primary)" }} />
        Datos leídos con IA
        <button
          type="button"
          onClick={onDescartar}
          className="ml-auto inline-flex items-center gap-1 text-xs underline"
        >
          <X size={12} aria-hidden={true} /> Descartar lectura
        </button>
      </p>
      {partes.length > 0 && (
        <p style={{ color: "var(--fg-muted)" }}>Además se guardan: {partes.join(", ")}.</p>
      )}
      <p style={{ color: "var(--fg-muted)" }}>
        Se adjuntan al expediente:{" "}
        {propuesta.archivos.map((a) => NOMBRE_ARCHIVO[a.tipo]).join(", ")}.
      </p>
    </div>
  )
}
